const memberCN = {
    MEMBER_01:'上传头像',
    MEMBER_02:'请选择行业',
    MEMBER_03:'请选择国家',
    MEMBER_04:'保存修改',
    MEMBER_05:'请输入数字',
    MEMBER_06:'请输入正确的邮箱地址',
    MEMBER_07:'上传头像图片只能是jpg/jpeg/bmp/png格式！',
    MEMBER_08:'上传头像图片大小不能超过 2MB!',
    MEMBER_09:'请输入原密码',
    MEMBER_10:'请输入新密码',
    MEMBER_11:'请再次输入新密码',
    MEMBER_12:'提示信息',
    MEMBER_13:'确定',
    MEMBER_14:'密码修改成功',
    MEMBER_15:'上传头像图片只能是 JPG 格式!',
    MEMBER_16:'总计',
    USE_BALANCE:'额度用完后，搜索查看时，使用账户余额付费',
}
export default memberCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_member.js